export default "__VITE_ASSET__vUgPNgP0__"